var _path, _path2, _path3;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ArrowRandom = function ArrowRandom(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.293 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L19.586 7l-2.293-2.293a1 1 0 0 1 0-1.414Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.603 8a4 4 0 0 0-3.277 1.706l-4.014 5.734A6.001 6.001 0 0 1 5.397 18H3a1 1 0 1 1 0-2h2.397a4.001 4.001 0 0 0 3.277-1.706l4.014-5.734A6 6 0 0 1 17.603 6H21a1 1 0 1 1 0 2h-3.397ZM17.293 20.707a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 0 0-1.414 1.414L19.586 17l-2.293 2.293a1 1 0 0 0 0 1.414Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.603 16a4 4 0 0 1-3.277-1.706l-.139-.2a1 1 0 0 0-1.639 1.147l.14.2A6 6 0 0 0 17.603 18H21a1 1 0 1 0 0-2h-3.397Zm-7.385-5.831a1 1 0 0 0 .246-1.393l-.152-.216A6 6 0 0 0 5.397 6H3a1 1 0 1 0 0 2h2.397a4 4 0 0 1 3.277 1.706l.152.217a1 1 0 0 0 1.392.246Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default ArrowRandom;